module.exports = __webpack_public_path__ + "img/9788949171050.d40ab680.jpg";